import React from 'react';
import { Divider, Switch, Tooltip } from 'antd';
import {
  DeleteOutlined,
  CopyOutlined,
} from '@ant-design/icons';

import Paragraphe from '../questionTypes/Paragraphe';
import ChoixMultiples from '../questionTypes/ChoixMultiples';
import Checkboxes from '../questionTypes/Checkboxes';
import ListeDeroulante from '../questionTypes/ListeDeroulante';
import UploadFichier from '../questionTypes/UploadFichier';
import InputDate from '../questionTypes/InputDate';
import InputHeure from '../questionTypes/InputHeure';
import Emails from '../questionTypes/Emails';
import Nombres from '../questionTypes/Nombres';
import ReponseCourte from '../questionTypes/ReponseCourte';
import ChoixMultipleShare from '../questionTypes/ChoixMultipleShare';
import CheckboxShare from '../questionTypes/CheckboxShare';
import ListDeroulanteShare from '../questionTypes/ListDeroulanteShare';

const QuestionItemShare = ({ question,disabled_ = true,value,onChange, onDelete, onDuplicate, onToggleRequired, isCollapsed , onChangeOptions}) => {
  const { id, label, type, options = [], required } = question;

 const renderInputByType = () => {
  switch (type) {
    case 'text':
      return <ReponseCourte disabled={disabled_} value={value} onChange={onChange} />;
    case 'textarea':
      return <Paragraphe disabled={disabled_} value={value} onChange={onChange}/>;
    case 'radio':
      return <ChoixMultipleShare options={options} onChange={onChange} value={value} disabled={disabled_} />;
    case 'checkbox':
      return <CheckboxShare options={options} onChange={onChange} value={value} disabled={disabled_} />;
    case 'select':
      return <ListDeroulanteShare options={options} onChange={onChange} value={value} disabled={disabled_} />;
    case 'file':
      return <UploadFichier disabled={disabled_} value={value} onChange={onChange} />;
    case 'date':
      return <InputDate disabled={disabled_} value={value} onChange={onChange} />;
    case 'time':
      return <InputHeure disabled={disabled_} value={value} onChange={onChange} />;
    case 'email':
      return <Emails disabled={disabled_} value={value} onChange={onChange} />;
    case 'number':
      return <Nombres disabled={disabled_} value={value} onChange={onChange}/>;
    default:
      return null;
  }
};

//   if (isCollapsed) {
//   return (
//     <div>
//       <div>{renderInputByType()}</div>
//     </div>
//   );
// }




  return (
    <div>
      
      <div style={{ marginTop: 8 }}>{renderInputByType()}</div>

    
      

      {!isCollapsed && (<>
        <Divider style={{ marginTop: '8%' }} />
        <div style={{ display: 'flex', gap: '24px', marginTop: 16, float: 'right' }}>
        <Tooltip title="Dupliquer">
          <CopyOutlined
            style={{ fontSize: 20, cursor: 'pointer' }}
            onClick={(e) => {
              e.stopPropagation();
              onDuplicate(id);
            }}
          />
        </Tooltip>

        <Tooltip title="Supprimer">
          <DeleteOutlined
            style={{ fontSize: 20, cursor: 'pointer' }}
            onClick={(e) => {
              e.stopPropagation();
              onDelete(id);
            }}
          />
        </Tooltip>

        <Tooltip title="Rendre obligatoire">
          <span
            onClick={(e) => {
              e.stopPropagation();
              onToggleRequired(id);
            }}
            style={{ cursor: 'pointer' }}
          >
            <span style={{ marginRight: '3px' }}>Obligatoire</span>
            <Switch checked={required} />
          </span>
        </Tooltip>
      </div></>)}
    </div>
  );
};

export default QuestionItemShare;
